/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import {
  checkFormHasError,
  handleBlurFormField,
  handleChangeFormField,
} from 'ui/forms/formHelpers';
import { useField } from 'formik';
import Select, { SelectProps } from 'ui/Select';

function FormSelect({ onChange, onBlur, children, ...rest }: SelectProps) {
  const [field, meta] = useField(rest?.inputProps as any);

  const handleChange = (event: React.ChangeEvent<any>, child: any) =>
    handleChangeFormField(field, event, onChange as any);

  const handleBlur = (event: React.FocusEvent<any>) => handleBlurFormField(field, event, onBlur);

  const hasError = checkFormHasError(meta);

  return (
    <Select
      error={hasError}
      {...(field as any)}
      {...rest}
      onChange={handleChange}
      onBlur={handleBlur}
    >
      {children}
    </Select>
  );
}

export default FormSelect;
